<script setup lang="ts">
type IconSize = 'sm' | 'md' | 'lg' | 'xl'

const props = withDefaults(
  defineProps<{
    name: string
    size?: IconSize
    label?: string
  }>(),
  {
    size: 'md',
    label: undefined,
  },
)

const classes = computed(() => [`app-icon--${props.size}`, props.name])
</script>

<template>
  <span
    class="app-icon"
    :class="classes"
    :role="label ? 'img' : undefined"
    :aria-label="label"
    :aria-hidden="label ? undefined : 'true'"
  />
</template>
